<template>
    <vx-card  slot="no-body" :title="$t('Decarbonization.Admin.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(roles.admins)">
      <menu-control :items="items">
      </menu-control>
    </vx-card>
</template>
<script>

import roles from './../../roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuControl
  },
  data() {
    return {
      roles,
      items : [
        {
          roles : roles.admins,
          icon : "LockIcon",
          to : "/bsg/decarbonization/admin/complexityParameters",
          i18nTitle : "Decarbonization.ComplexityParameter.Title"
        },
        {
          roles : roles.admins,
          icon : "LockIcon",
          to : "/bsg/decarbonization/admin/energySupplyTemplates",
          i18nTitle : "Decarbonization.EnergySupplyTemplate.Title"
        },
        {
          roles : roles.admins,
          icon : "LockIcon",
          to : "/bsg/decarbonization/admin/gridEfficiencyTemplates",
          i18nTitle : "Decarbonization.GridEfficiencyTemplate.Title"
        },
        {
          roles : roles.admins,
          icon : "LockIcon",
          to : "/bsg/decarbonization/admin/energySourceUnitConversion",
          i18nTitle : "Decarbonization.EnergySourceUnitConversion.Title"
        }
      ]
    }
  }
};
</script>